export const ERROR_MESSAGES = {
  DEFAULT: 'There was an issue. Please refresh the page and try again.',
  UNABLE_TO_SAVE_UPDATED_PREFERENCES:
    'There was an issue saving your updated preferences. Please refresh the page and try again.',
  UNABLE_TO_SEND_MESSAGE:
    'Unable to send message. Please refresh the page and try again.',
  UNABLE_TO_LOAD_ACTIVITY: 'Unable to load activity. Please try again later.',
  UNABLE_TO_LOAD_EMPLOYEE_INFORMATION: 'Unable to load employee information',
  UNABLE_TO_LOAD_PORTAL: 'Unable to load the portal',
  DUPLICATE_CANDIDATE_EMAIL_MESSAGE: 'Candidate with this email already exists',
  DUPLICATE_CANDIDATE_EMAIL_SELECT_EXISTING_MESSAGE:
    'Candidate email already exists. Please select this existing candidate or use a new email.',
  TRANSFER_ALREADY_APPLIED: 'Candidate already exists on this job',
  DUPLICATE_NAME_MESSAGE: 'This name already exists in the organization.',
  DUPLICATE_DISPOSITION_CODE_MESSAGE:
    'A disposition code with this description already exists.',
  INVALID_BILLING_CONTACTS:
    'Some billing contact details were not accepted. Check the email addresses and try again.',

  // Job Status Conflict Errors
  JOB_ALREADY_APPROVED_MESSAGE: 'This job has already been approved.',
  JOB_ALREADY_DECLINED_MESSAGE: 'This job has already been declined.',
  JOB_ALREADY_ON_HOLD_MESSAGE: 'This job is already on hold.',

  // Job Status Action Errors
  JOB_OPEN_PUBLIC_FAILED: 'Failed to open job as public. Please try again.',
  JOB_OPEN_INTERNAL_FAILED: 'Failed to open job as internal. Please try again.',
  JOB_CLOSE_FAILED: 'Failed to close job. Please try again.',
  JOB_PUBLISH_FAILED: 'Failed to publish job to career site. Please try again.',
  JOB_UNPUBLISH_FAILED: 'Failed to open job as internal . Please try again.',
  JOB_STATUS_UPDATE_FAILED: 'Failed to update job status. Please try again.',
  JOB_ID_CONVERSION_FAILED:
    'Unable to process job information. Please refresh the page and try again.',
  JOB_PLACE_ON_HOLD_FAILED: 'Failed to place job on hold. Please try again.',
  INDEED_PREDICTION_FAILED:
    'Cannot fetch performance estimate. Sponsorship can proceed, or please try again later if a performance estimate is required.',
  FETCH_ALL_CANDIDATES_FAILED:
    'Failed to load all candidates. Please try again.',
  INTEGRATION_MAPPING_DUPLICATE_TAB:
    'A DocuSign tab with that name already exists. Choose a different name.',
};
